import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../customHooks";
import HeaderDetails from "./headerDetails";
import QuaterSezionali from "./quaterSezionali";
import Tags from "./tags";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DocumentDetailsCollapsedInfo from "./documentDetailsCollapsedInfo";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { useSelector } from "react-redux";

const Details = () => {
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const detailsDocument = useSelector(state => state.detailsDocument);  
  const main = useSelector(state => state.main);
  const tspay = useSelector(state => state.tspay);

  const accountantIdSelected = main.accountantIdSelected;
  const accountantSelected = main.accountantSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const myType = main.myType;  

  const [isInvoice, setIsInvoice] = useState(false);
  const [configStatus, setConfigStatus] = useState("");
  const { isPermissionDeadlines, isPermissionDocumentInvoices, isPermissionsDeadlinesEInvoices } = usePermissions(currentPermissions);

  useEffect(() => {
    if (!detailsDocument.info.details) return;  
    setIsInvoice(detailsDocument.info.details.einvoice);
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, []);

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);    
  }, [detailsDocument]);

  let documentId = null;
  if (detailsDocument.info.details !== null && detailsDocument.info.details !== undefined) {
    documentId = detailsDocument.info.details.documentId;
  }

  let hasDeadlineToPay = false;
  if (detailsDocument.info.details && detailsDocument.info.details.deadlines && detailsDocument.info.details.deadlines !== []) {
    let listaScadenze = [...detailsDocument.info.details.deadlines];
    let listFiltered = listaScadenze.filter((el) => el.payment.step === "to_be_paid");
    if (listFiltered.length > 0) {
      hasDeadlineToPay = true;
    }
  }

  return detailsDocument.info.details ? (
    <div style={{ paddingTop: "24px", paddingLeft: "10px" }}>
      <div style={{ display: "flex" }}>
        <div style={{ flex: "1 0 auto" }}>
          <QuaterSezionali
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            companySelected={companySelected}
            clientIdSelected={clientIdSelected}
          />
        </div>
      </div>

      {(isInvoice && isPermissionDocumentInvoices && isPermissionDeadlines) || (!isInvoice && isPermissionDeadlines) ? (
        <div>
          <HeaderDetails myType={myType} currentPermissions={currentPermissions} />
        </div>
      ) : null}

      <div style={{ padding: "0" }}>
        <div className="borderSeparatorSection noBorder">
          <Tags />
          {myType !== "STUDIO" && isPermissionsDeadlinesEInvoices && isInvoice && hasDeadlineToPay && configStatus === "LINKED" ? (
            <div style={{ display: "inline-block", marginRight: "16px", marginBottom: "16px" }}>
              <Button
                kind="tertiary"
                onClick={() => {
                  navigate("/tspay-payment", {                    
                    state: {
                      documentId: documentId,
                      deadlines: detailsDocument.info.details.deadlines,
                      from: "documents",
                      backTo: "/dettaglio-documento/" + documentId
                    }
                  });
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:TSPAY-PAGASUBITO");
                  }
                }}
              >
                <FormattedMessage id={"deadlines.pages.detail.registerPaymentWithTsPay"} />
              </Button>
            </div>
          ) : null}
          <DocumentDetailsCollapsedInfo
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            companySelected={companySelected}
            clientIdSelected={clientIdSelected}
            documentId={documentId}
            auth={auth}              
          />
        </div>
      </div>
    </div>
  ) : (
    <>
      <div style={{ textAlign: "center", height: "100vh" }}>
        <Spin
          indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
          size="large"
          tip={
            <span>
              <FormattedMessage id="generic.loadingMessage" />
            </span>
          }
          style={{ fontSize: "20px", marginTop: "200px" }}
        />
      </div>
    </>
  );
};

export default Details;